import { Box, Button, Paper, Typography } from "@mui/material";
import { FriendsList } from "./FriendsList";
import { useEffect, useRef, useState } from "react";
import { MyListApi } from "../utils/restApi";
import { useDispatch, useSelector } from "react-redux";
import { RequestFriendDialog } from "./RequestFriendDialog";
import { addNotification } from "../slices/notificationSlice";
import { useParams } from "react-router-dom";

export const Friends = () => {

    const user = useSelector(state => state.login.user);
    const ref = useRef();
    const { userId } = useParams();
    const dispatch = useDispatch();
    const [friends, setFriends] = useState({
        items: [],
        count: 0,
        page: 0,
        perPage: 0,
    });

    useEffect(() => {
        MyListApi.getFriends(user.id)
            .then(data => {
                setFriends(data);
            })
            .catch(error => {
                dispatch(addNotification({
                    message: error.message,
                    type: 'error',
                }));
            });
    }, []);

    if (user?.id !== userId) {
        return (
            <Box>
                <Typography>You can't view other people's friends. Thats creepy.</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box><Typography component="h2" variant="h2">Friends</Typography></Box>
            <Paper variant="outlined">
                <Box sx={{ p: 1, display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: 1 }}>
                    <Button variant="contained" size="small" onClick={() => {}}>Block User</Button>
                    <Button variant="contained" size="small" onClick={() => ref.current.openRequestFriend()}>Add Friend</Button>
                </Box>
            </Paper>
            <Paper>
                <Box>
                    <RequestFriendDialog ref={ref} />
                    <FriendsList friends={friends.items} />
                </Box>
            </Paper>
        </Box>
    );
}